import React, { useEffect } from 'react';
import { Check, X, AlertTriangle, Loader2, Info } from 'lucide-react';

/**
 * TOAST HORAPILOT - DESIGN MINIMAL ÉLÉGANT
 * Style épuré avec animation douce - COULEURS HORAPILOT UNIQUEMENT
 */
export const Toast = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    if (type === 'loading') return;
    
    const timer = setTimeout(() => {
      onClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose, type]);

  // ✅ Configuration couleurs HoraPilot UNIQUEMENT
  const config = {
    success: {
      icon: Check,
      gradient: 'linear-gradient(135deg, #448696 0%, #6fa3b0 100%)',
      color: '#448696'
    },
    error: {
      icon: X,
      gradient: 'linear-gradient(135deg, #fed774 0%, #fdd24e 100%)',
      color: '#fed774'
    },
    loading: {
      icon: Loader2,
      gradient: 'linear-gradient(135deg, #448696 0%, #6fa3b0 100%)',
      color: '#448696',
      spin: true
    },
    warning: {
      icon: AlertTriangle,
      gradient: 'linear-gradient(135deg, #fed774 0%, #fdd24e 100%)',
      color: '#fed774'
    },
    info: {
      icon: Info,
      gradient: 'linear-gradient(135deg, #448696 0%, #6fa3b0 100%)',
      color: '#448696'
    }
  };

  const current = config[type] || config.info;
  const Icon = current.icon;

  return (
    <>
      <style jsx>{`
        @keyframes fadeSlideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .toast-container {
          animation: fadeSlideIn 0.4s ease-out;
        }
      `}</style>

      <div className="fixed top-6 right-6 z-[99999] toast-container">
        {/* Toast minimal */}
        <div 
          className="flex items-center gap-4 px-6 py-4 rounded-2xl shadow-2xl backdrop-blur-md"
          style={{ 
            backgroundColor: '#ffffffff',
            border: `2px solid ${current.color}20`,
            minWidth: '320px',
            maxWidth: '460px'
          }}
        >
          {/* Icon circulaire avec gradient */}
          <div 
            className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center shadow-lg"
            style={{ background: current.gradient }}
          >
            <Icon 
              size={24} 
              className={current.spin ? 'animate-spin' : ''}
              color="#ffffff"
              strokeWidth={3}
            />
          </div>

          {/* Message */}
          <p className="flex-1 font-semibold text-gray-800 text-base">
            {message}
          </p>

          {/* Bouton fermer minimaliste */}
          {type !== 'loading' && (
            <button
              onClick={onClose}
              className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            >
              <X size={16} className="text-gray-400" />
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Toast;